import React, { useContext } from "react";

import Card from "./Card";
import { RootStoreContext } from "../store/rootStore";
import { observer } from "mobx-react-lite";
import { ICard } from "../models/card";

interface IProps {
  live: boolean;
}

const ShowFormColumns:React.FC<IProps> = observer(({live}) => {

  const rootStore = useContext(RootStoreContext);
  const {cards} : {cards: ICard[]} = rootStore.cardsStore;
  const {toggleFilterPanelState} = rootStore.filterPanelStore;
  const {allChosenSubjects, allSubjectsByType, subjects} = rootStore.subjectStore;
  const {allChosenYears, setYearClickedOpen} = rootStore.yearsStore;

  
  return (
    <div className='the-wall__body'>

      {live &&
        <div className='the-wall__forms the-wall__column'>
          {allChosenYears.map(form => 
              <div className='the-wall__form' key={form.slug}>
                <div  className='the-wall__form-holder'>
                  <div className='the-wall__form-label' onClick={(e) => setYearClickedOpen(form)}>{form.name}</div>
                </div>
              </div>
          )}
        </div>
      }
      <div className='the_wall__cards'>
        {allChosenSubjects.map((subject, subjectIndex) => 
          <div key={subject.slug} className='the-wall__column'>
            {allChosenYears.map((form, formIndex) =>
              <div className='the-wall__card' key={form.slug}>
                {cards.filter(card =>
                  card.subjectId == subject.termTaxonomyId &&
                  card.formId == form.termTaxonomyId
                  ).map(card => {
                    return(
                      <Card key={card.slug} card={card} subject={subject} subjectIndex={subjectIndex} formIndex={formIndex} />
                    )
                  })
                }

                {live && cards.filter(card =>
                  card.subjectId == subject.termTaxonomyId &&
                  card.formId == form.termTaxonomyId
                  ).length == 0 && 
                  <Card key={`empty${subject.slug}-${form.slug}`} subject={subject} subjectIndex={subjectIndex} formIndex={formIndex} />
                }

                {!live && cards.filter(card =>
                  card.subjectId == subject.termTaxonomyId &&
                  card.formId == form.termTaxonomyId
                  ).length == 0 &&
                  <Card card={cards.filter(card => card.subjectId == subject.termTaxonomyId).sort(() => Math.random() - 0.5).reduce((result, card) => Math.random() < 0.8 ? card : null, null)} key={`empty${subject.slug}-${form.slug}`} subject={subject} subjectIndex={subjectIndex} formIndex={formIndex} />
                }

                

              </div>
            )}
          </div>
        )}
        {
          allChosenSubjects.length < subjects.length &&
            <div className='the_wall__add-subject' onClick={() => toggleFilterPanelState()}>
              <div>
                <div><i className="fa-solid fa-plus"></i></div>
                Add subject(s)
              </div>
            </div>
        }
        
      </div>

    </div>
  )
});

export default ShowFormColumns;
